import { defineMessages } from 'react-intl'

export default defineMessages({
  redirectCountdown: {
    id: 'containers.PublicLiveSessionRedirectPage.redirectCountdown',
    defaultMessage: "You will be redirected to the session in {time}",
  },
  waitMessage: {
    id: 'containers.PublicLiveSessionRedirectPage.waitMessage',
    defaultMessage: 'The session will open automatically when it’s time. Please wait...',
  },
  waitingMessage: {
    id: 'containers.PublicLiveSessionRedirectPage.waitingMessage',
    defaultMessage: "Waiting for the session to become joinable...",
  },
  readyToJoin: {
    id: 'containers.PublicLiveSessionRedirectPage.readyToJoin',
    defaultMessage: 'You can now join the session by clicking the button below.',
  },
  joinNow: {
    id: 'containers.PublicLiveSessionRedirectPage.joinNow',
    defaultMessage: "Join Now",
  },
  buttonDisabledHint: {
    id: 'containers.PublicLiveSessionRedirectPage.buttonDisabledHint',
    defaultMessage: 'The "Join Now" button will be enabled when the session is ready.',
  },
  liveSessionNotFound: {
    id: 'containers.PublicLiveSessionRedirectPage.liveSessionNotFound',
    defaultMessage: 'Sorry but we are not able to find your LiveSession. Please contact your PM',
  },
})
